import React from 'react';
import { Modal } from "src/components";
import { ChainPlusIcon } from 'src/components/Icons';
import * as Ui from './styles';

export const GenericModal = function({
  // Contexto interno à modal
  children,
  // Título da tooltip
  tooltipTitle = '',
  // Controle de disable nos botões da modais
  okBtnClickable = true,
  // Outras props do componente modal
  ...props
}) {
  return (
    <Ui.Wrapper okBtnClickable={okBtnClickable}>
      <Modal iconComponent={<ChainPlusIcon />} {...props } okBtnClickable={okBtnClickable}>
        <Ui.AbsoluteContainer>
          <Ui.ToolTip>
            <Ui.LabelSmall>
              {tooltipTitle}
            </Ui.LabelSmall>
          </Ui.ToolTip>
          <Ui.Container>
            {children}
          </Ui.Container>
        </Ui.AbsoluteContainer>
      </Modal>
    </Ui.Wrapper>
  )
}